import { getAuth } from 'firebase/auth'
import type { User } from 'fitify-types/src/types/user'
import type { UserLocation } from 'fitify-ui/src/server/types/user-location'

import type { RedeemVoucherResponseData } from '../types/nextApi'

const getAuthorizationHeader = async (): Promise<HeadersInit> => {
  const auth = getAuth()

  if (auth.currentUser) {
    const token = await auth.currentUser.getIdToken()
    return {
      Authorization: token,
    }
  }

  return {}
}

export const fetchRedeemVoucher = async (
  code: string
): Promise<RedeemVoucherResponseData> => {
  const authorizationHeader = await getAuthorizationHeader()
  const response = await fetch('/api/redeem-voucher', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authorizationHeader,
    },
    body: JSON.stringify({
      code,
    }),
  })
  return response.json() as Promise<RedeemVoucherResponseData>
}

export const fetchDetectLocation = async (): Promise<UserLocation | null> => {
  const response = await fetch('/api/detect-location', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  })
  if (!response.ok) {
    return null
  }
  return response.json() as Promise<UserLocation>
}

export const fetchUserProfile = async (): Promise<User | null> => {
  const authorizationHeader = await getAuthorizationHeader()
  const response = await fetch('/api/user-profile', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authorizationHeader,
    },
  })
  return response.json() as Promise<User | null>
}
